<template>
  <div v-if="owner" class="user-alert-container">
    <b-alert v-if="user.id !== owner.id" show variant="warning" class="mb-2" dismissible> <!-- Visas för alla som inte är owner när de besöker en portfölj -->
        <div class="alert-body">Du hanterar nu {{owner.first_name}} {{owner.last_name}}s portfölj. Alla ändringar du gör i portföljen loggas på din användare.</div> 
    </b-alert>
     <b-alert v-if="getReadOnlyMode" show variant="primary" class="mb-2"> <!-- visas endast om portföljen är satt i läsläge -->
        <h4 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Läsläge är aktiverat</h4> 
        <div class="alert-body">När läsläge är aktiverat kan alla med behörighet läsa innehållet i portföljen men ingen kan redigera portföljen. <router-link :to="{name: 'settings'}">Gå till Inställningar för att stänga av läsläge ››</router-link></div>
    </b-alert>
    <b-alert v-if="getBlockedMode" show variant="danger" class="mb-2" dismissible> <!-- visas endast för Owner om portföljen är blockerad -->
        <h4 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Portföljen är blockerad</h4>
        <div class="alert-body">När portföljen är blockerad kan ingen förutom du själv komma åt innehållet portföljen. <router-link :to="{name: 'settings'}">Gå till Inställningar för att avblockera portföljen ››</router-link></div>
    </b-alert>
  </div>
</template>

<script>
import {
  BAlert
} from 'bootstrap-vue'
import { mapGetters } from 'vuex';


export default {
  components: {
    BAlert
  },
  data(){
    return{
      readOnlyMode: Boolean,
      blockedMode: Boolean
    }
  },
  computed: {
    ...mapGetters(['getActivePortfolio']),
    ...mapGetters('userAccount', ['getPortfolioOwner', 'getUser']),
    getReadOnlyMode: function(){
      return this.getActivePortfolio.read_only_mode;
    },
    getBlockedMode: function(){
      return this.getActivePortfolio.blocked;
    },
    user: function(){
      return this.getUser;
    },
    owner: function(){
      return this.getPortfolioOwner;
    },
  },
  watch: {
    getReadOnlyMode: function(newVal){
      this.readOnlyMode = newVal;
    },
    getBlockedMode: function(newVal){
      this.blockedMode = newVal;
    },
  }
}
</script>

<style scoped>
  a{
    text-decoration: underline;
  }
</style>